import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TransactionRequestDto } from '../dtos/request-dto/transactions-request.dto';
import { TransactionTrailResponseDto } from '../dtos/response-dto/transaction-response-dto';

@Injectable({
    providedIn: 'root'
})
export class TransactionsService {
    public constructor(private http: HttpClient) { }

    public postTransactionReport(data: TransactionRequestDto): Observable<TransactionTrailResponseDto> {
        return this.http.post<TransactionTrailResponseDto>(environment.baseUrl + 'Report/transaction', data);
    }
}
